<template>
    <EChart
        :options="chartData"
        :group-by="currentGroupBy"
        card
        type="time"
        :header="$t('purchasedItemsInTime')"
        :tooltip="$t('tooltipNewReportIsCreated')"
        :loading="request.getLoading()"
    >
        <template #nav>
            <div :key="spaceId" class="d-flex gap-3 flex-column">
                <DropdownFilter v-model="currentGroupBy" :items="['day', 'month', 'quarter', 'year']" :prefix="`${$t('range')}: `" :disabled="request.getLoading()" />
            </div>
        </template>
    </EChart>
</template>



<script>
    import { startOfDay, startOfMonth, startOfQuarter, startOfYear } from 'date-fns';
    import EChart from '@/components/common/EChart.vue';
    import DropdownFilter from '@/components/common/DropdownFilter.vue';

    export default {
        name: 'AverageQuantityInTime',
        components: {
            EChart,
            DropdownFilter,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestData2,
                currentGroupBy: 'day',
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            data() {
                return this.parentComponent.data2;
            },
            chartData() {
                if (!this.data?.length) return { series: [] };

                // Początek kubełka wg groupBy (lokalny czas)
                const getBucketStartTimestamp = (timestampMs, groupBy) => {
                    const originalDate = new Date(Number(timestampMs));
                    switch (groupBy) {
                        case 'day':
                            return startOfDay(originalDate).getTime();
                        case 'month':
                            return startOfMonth(originalDate).getTime();
                        case 'quarter':
                            return startOfQuarter(originalDate).getTime();
                        case 'year':
                            return startOfYear(originalDate).getTime();
                        default:
                            return startOfDay(originalDate).getTime();
                    }
                };

                // Agregacja ilości do kubełków
                const groupedData = {};

                this.data.forEach(item => {
                    const originalTimestamp = Number(new Date(item.createdAt));
                    const bucketStartTs = getBucketStartTimestamp(originalTimestamp, this.currentGroupBy);
                    if (!groupedData[bucketStartTs]) groupedData[bucketStartTs] = 0;
                    groupedData[bucketStartTs] += Number(item.quantity || 0);
                });

                // Sort chronologiczny po bucketStartTs
                const sortedBuckets = Object.keys(groupedData)
                    .map(Number)
                    .sort((a, b) => a - b);

                const quantities = sortedBuckets.map(bucketTs => groupedData[bucketTs]);

                return {
                    legend: {
                        show: false,
                    },
                    xAxis: {
                        data: sortedBuckets,
                    },
                    yAxis: {
                        minInterval: 1,
                    },
                    series: [
                        {
                            name: this.$t('quantityPieces'),
                            type: 'bar',
                            data: quantities,
                        },
                    ],
                };
            },
        },
        watch: {
            spaceId() {
                this.resetFilters();
            },
        },
        methods: {
            resetFilters() {
                this.currentGroupBy = 'day';
            },
        },
        created() {
            this.parentComponent.$on('resetFilters', this.resetFilters);
        },
        beforeDestroy() {
            this.parentComponent.$off('resetFilters', this.resetFilters);
        },
    };
</script>
